export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/index.js